import React, { useState, useEffect } from "react";
import { Typography, Grid, Card, Avatar, Button, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { colors } from "../components/Theme/WebTheme";
import moment from "moment/min/moment-with-locales";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { makeStyles } from "@mui/styles";
import { renderRatingStars } from "../common/sharedFunctions";
import { api } from "common";
const { formatPublicName } = api;
const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: "10px",
    backgroundColor: "#fff",
    minHeight: 100,
    marginTop: 5,
    marginBottom: 20,
    boxShadow: `0px 2px 5px ${colors.THIRDCOLOR}`,
  },
  txt: {
    padding: 10,
    fontWeight: "bold",
    minHeight: 60,
    backgroundColor: colors.SECONDARY,
    color: colors.BLACK,
    boxShadow: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
function BookingDetails() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const bookinglistdata = useSelector((state) => state.bookinglistdata);
  const role = useSelector(state => state.auth.profile.usertype);
  const userInfo = useSelector(state => state.auth.profile);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const settings = useSelector((state) => state.settingsdata.settings);
  const classes = useStyles();
  useEffect(() => {
    if (bookinglistdata.bookings) {
      const booking = bookinglistdata.bookings.filter(
        (item) => item.id === id.toString()
      )[0];

      if (booking) {
        setData(booking);
      } else {
        navigate("/404");
        setData([]);
      }
    }
  }, [bookinglistdata.bookings, id, navigate]);

  const TimeDisplay = ({ timestamp }) => {
    const [hours, minutes, seconds] = timestamp.split(':');

    const formattedHours = hours.padStart(2, '0');
    const formattedMinutes = minutes.padStart(2, '0');
    const formattedSeconds = seconds.padStart(2, '0');

    const timeString = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

    return timeString;
  };

  const { state } = useLocation();

  const renderGridItem = (item, isRTL) => {
    if (item.key === "drop_address" || item.key === "pickup_address" || item.key === "custom_fields") {
      return (
        <Grid
          key={item.key}
          container
          spacing={1}
          sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
          style={{
            justifyContent: "center",
            alignItems: "center",
            minHeight: 60,
            ...item.addressGridStyle
          }}
        >
          <Grid item xs={12}>
            <Typography
              style={{
                fontSize: 16,
                padding: 2,
                wordBreak: 'break-word',
                textAlign: isRTL === "rtl" ? "right" : "left",
                ...item.typographyStyleAddress,
                fontWeight: item.key === "custom_fields" ? "bold" : ""
              }}
            >
              {item.label}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {item.key === "custom_fields" ? item.value :
              <Typography
                style={{
                  fontSize: 16,
                  padding: 2,
                  textAlign: isRTL === "rtl" ? "right" : "left",
                  ...item.style,
                }}
              >
                {item.value}
              </Typography>
            }

          </Grid>
        </Grid>
      );
    }

    return (
      <Grid
        key={item.key}
        container
        spacing={1}
        sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        style={{
          justifyContent: "center",
          alignItems: "center",
          minHeight: 60,
          ...item.addressGridStyle
        }}
      >
        <Grid item xs={3}>
          <Typography
            style={{
              fontSize: 16,
              padding: 2,
              textAlign: isRTL === "rtl" ? "right" : "left",
              ...item.typographyStyleAddress
            }}
          >
            {item.label}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            style={{
              fontSize: 16,
              padding: 2,
              letterSpacing: -1,
              textAlign: "end",
            }}
          >
            -----
          </Typography>
        </Grid>
        <Grid item xs={7} sx={{ ...(item.key === "booking_status_web" && { display: 'flex', justifyContent: 'flex-end', }) }}>

          <Typography
            style={{
              fontSize: 16,
              padding: 2,
              wordBreak: 'break-word',
              textAlign: isRTL === "rtl" ? "left" : "right",
              ...item.style,
            }}
          >
            {item.value}
          </Typography>
        </Grid>
      </Grid>
    );
  };


  const renderTypography = (text) => {
    return (
      <Typography
        className={classes.txt}
        style={{
          borderBottomRightRadius: isRTL ? "90px" : "",
          borderBottomLeftRadius: isRTL ? "" : "90px",
        }}
        variant="h5"
      >
        {text}
      </Typography>
    );
  };


  return (
    <>
      <div dir={isRTL === "rtl" ? "rtl" : "ltr"}
        style={{
          marginBottom: 20,
        }}
      >
        <Button
          variant="text"
          onClick={() => {
            if (state?.from) {
              navigate(state.from);
            } else {
              navigate('/bookings', { state: { pageNo: state?.pageNo } });
            }
          }}
        >
          <Typography
            style={{
              margin: "10px 10px 0 5px",
              textAlign: isRTL === "rtl" ? "right" : "left",
              fontWeight: "bold",
              color: colors.MAIN_COLOR
            }}
          >
            {`<<- ${t("go_back")}`}
          </Typography>
        </Button>
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
            <Grid item>
              <Card className={classes.card}>
                {renderTypography(t("ride_information"))}
                <Grid container direction="column" style={{ padding: 10 }}>
                  {data &&
                    [
                      { key: "booking_id", label: t("booking_id"), value: data.id },
                      { key: "booking_ref", label: t("booking_ref"), value: data.reference },
                      {
                        key: "booking_status_web",
                        label: t("booking_status_web"),
                        value: t(data.status),
                        style: {
                          backgroundColor:
                            data?.status === "CANCELLED"
                              ? colors.RED
                              : data?.status === "COMPLETE"
                                ? colors.GREEN
                                : colors.YELLOW,
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "10px",
                          textAlign: "center",
                          padding: 3,
                          width: '8rem',
                        },
                      },
                      {
                        key: "trip_start_date", label: t("trip_start_date"), value: data?.tripdate
                          ? moment(data?.tripdate).format("lll")
                          : ""
                      },
                      { key: "trip_start_time", label: t("trip_start_time"), value: data?.trip_start_time && TimeDisplay({ timestamp: data?.trip_start_time }) },
                      { key: "trip_end_time", label: t("trip_end_time"), value: data?.trip_end_time && TimeDisplay({ timestamp: data?.trip_end_time }) },
                      {
                        key: "parcel_type_web",
                        label: t("parcel_type_web"),
                        value: data.parcelTypeSelected
                          ? data.parcelTypeSelected.amount > 0
                            ? `${data.parcelTypeSelected.description} (${data.parcelTypeSelected.amount})`
                            : data.parcelTypeSelected.description
                          : ""
                      },
                      {
                        key: "parcel_option",
                        label: t("parcel_option"),
                        value: data.optionSelected
                          ? data.optionSelected.amount > 0
                            ? `${data.optionSelected.description} (${data.optionSelected.amount})`
                            : data.optionSelected.description
                          : ""
                      },
                      { key: "deliveryPerson", label: t("deliveryPerson"), value: data?.deliveryPerson },
                      {
                        key: "deliveryPersonPhone", label: t("deliveryPersonPhone"), value: data.deliveryPersonPhone ? (settings.AllowCriticalEditsAdmin
                          ? data.deliveryPersonPhone
                          : t("hidden_demo")) : ""
                      },

                      { key: "take_pickup_image_web", label: t("take_pickup_image_web"), value: data.pickup_image ? data.pickup_image : "", type: 'image', alt: "pickup_image" },
                      { key: "take_deliver_image_web", label: t("take_deliver_image_web"), value: data.deliver_image ? data.deliver_image : "", type: 'image', alt: "deliver_image" },
                      { key: "tripInstructions", label: t("tripInstructions"), value: data?.tripInstructions },
                      { key: "child_seat", label: t("child_seat") || "Child Seat", value: (data?.childSeat || data?.child_seat) ? (t("yes") || "Yes") : (t("no") || "No") },
                      { key: "cancellation_reason", label: t("cancellation_reason"), value: data?.reason },
                      { key: "otp", label: t("otp"), value: data?.otp },
                      { key: "total_time", label: t("total_time"), value: data?.total_trip_time },
                      {
                        key: "distance_web", label: t("distance_web"), value: data.distance ? (settings.convert_to_mile
                          ? data?.distance + t("mile")
                          : data?.distance + " " + t("km")) : ""
                      },
                      { key: "pickUpInstructions_web", label: t("pickUpInstructions_web"), value: data?.pickUpInstructions },
                      { key: "deliveryInstructions", label: t("deliveryInstructions"), value: data?.deliveryInstructions },
                      { key: "otherPerson", label: t("otherPerson"), value: data?.otherPerson },
                      { key: "otherPersonPhone", label: t("otherPersonPhone"), value: data?.otherPersonPhone },
                      { key: "feedback_driver", label: (!t("feedback_on_driver") || t("feedback_on_driver") === "feedback_on_driver") ? "Feedback on Driver" : t("feedback_on_driver"), value: data?.feedback },
                      { key: "feedback_customer", label: (!t("feedback_on_customer") || t("feedback_on_customer") === "feedback_on_customer") ? "Feedback on Customer" : t("feedback_on_customer"), value: data?.driver_feedback || data?.driverFeedback },
                      {
                        key: "custom_fields",
                        label: t("custom_fields"),
                        value: (data.customFieldsObj && Object.values(data.customFieldsObj)
                          .filter((item) => item.field_type !== "none")
                          .map((item, index) => (
                            <Typography
                              key={index}
                              style={{
                                fontSize: 16,
                                padding: 2,
                                textAlign: isRTL === "rtl" ? "right" : "left",
                                wordWrap: "break-word",
                              }}
                            >
                              {item.field_name + ":" + item.value}
                            </Typography>
                          )))
                      },
                      {
                        key: "pickup_address", label: t("pickup_address"), value: data?.pickupAddress, addressGridStyle: {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "row",
                          minHeight: 60,
                          marginBottom: 20,
                        }, typographyStyleAddress: { color: "green" }
                      },
                      { key: "drop_address", label: t("drop_address"), value: data?.dropAddress, typographyStyleAddress: { color: "red", } },
                    ].map((item) =>
                      item.type === "image" && item.value ? (
                        <Grid
                          key={item.key}
                          container
                          spacing={1}
                          sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 60,
                          }}
                        >
                          <Grid item xs={3}>
                            <Typography
                              style={{
                                fontSize: 16,
                                padding: 2,
                                textAlign: isRTL === "rtl" ? "right" : "left",
                              }}
                            >
                              {item.label}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              style={{
                                fontSize: 18,
                                padding: 2,
                                letterSpacing: -1,
                                textAlign: "end",
                              }}
                            >
                              -----
                            </Typography>
                          </Grid>
                          <Grid item xs={7} sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '.5rem' }}>
                            <img
                              src={item.value}
                              alt={item.alt}
                              style={{
                                width: 120,
                                height: 'auto',
                              }}
                            />
                          </Grid>
                        </Grid>
                      ) :
                        item.value ? renderGridItem(item, isRTL) : null
                    )}
                </Grid>

              </Card>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Grid item>
              <Card className={classes.card}>
                {renderTypography(t("payment_info"))}
                <Grid container direction="column" style={{ paddingRight: 15, paddingLeft: 15, paddingBottom: 15 }}>
                  {data &&
                    [
                      {
                        key: "trip_cost", label: t("trip_cost"), value: userInfo.swipe_symbol
                          ? data?.trip_cost + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.trip_cost
                      },
                      {
                        key: "Customer_paid", label: t("Customer_paid"), value: data?.customer_paid ? (userInfo.swipe_symbol
                          ? data?.customer_paid + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.customer_paid) : ""
                      },
                      {
                        key: "discount_ammount",
                        label: t("discount_ammount"),
                        value: userInfo.swipe_symbol
                          ? data?.discount + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.discount,
                      },
                      {
                        key: "driver_share", label: t("driver_share"), value: role !== "customer" && (userInfo.swipe_symbol
                          ? data?.driver_share + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.driver_share)
                      },
                      {
                        key: "fleet_admin_comission", label: t("fleet_admin_comission"), value: role !== "customer" && (data?.fleetCommission && parseFloat(data?.fleetCommission) > 0 ? (userInfo.swipe_symbol
                          ? data?.fleetCommission + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.fleetCommission) : "")
                      },
                      {
                        key: "convenience_fee", label: t("convenience_fee"), value: userInfo.swipe_symbol
                          ? data?.convenience_fees + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.convenience_fees
                      },
                      {
                        key: "tipamount", label: t("tipamount"), value: data?.tipamount && (userInfo.swipe_symbol
                          ? data?.tipamount + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.tipamount)
                      },
                      {
                        key: "cancellationFee", label: t("cancellationFee"), value: userInfo.swipe_symbol
                          ? data.cancellationFee
                            ? data.cancellationFee
                            : (0).toFixed(settings.decimal) +
                            " " +
                            userInfo.symbol
                          : userInfo.symbol + " " + data.cancellationFee
                            ? data.cancellationFee
                            : (0).toFixed(settings.decimal)
                      },
                      {
                        key: "payment_gateway", label: t("payment_gateway"), value: data?.gateway
                      },
                      { key: "payment_mode_web", label: t("payment_mode_web"), value: data?.payment_mode ? data.payment_mode : "" },
                      {
                        key: "cash_payment_amount", label: t("cash_payment_amount"), value: data?.cashPaymentAmount ? (userInfo.swipe_symbol
                          ? data?.cashPaymentAmount + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.cashPaymentAmount) : ""
                      },
                      {
                        key: "card_payment_amount", label: t("card_payment_amount"), value:
                          data?.cardPaymentAmount ? (userInfo.swipe_symbol
                            ? data?.cardPaymentAmount + " " + userInfo.symbol
                            : userInfo.symbol + " " + data?.cardPaymentAmount) : ""
                      },
                      {
                        key: "wallet_payment_amount", label: t("wallet_payment_amount"), value:
                          data?.usedWalletMoney ? (userInfo.swipe_symbol
                            ? data?.usedWalletMoney + " " + userInfo.symbol
                            : userInfo.symbol + " " + data?.usedWalletMoney) : ""
                      },
                      {
                        key: "payable_ammount", label: t("payable_ammount"), value: data?.payableAmount ? (userInfo.swipe_symbol
                          ? data?.payableAmount + " " + userInfo.symbol
                          : userInfo.symbol + " " + data?.payableAmount) : ""
                      },
                    ].map((item) =>
                      item.value ? renderGridItem(item, isRTL) : null
                    )}
                </Grid>


              </Card>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Grid item>
              <Card className={classes.card}>
                {renderTypography(t("driver_info"))}
                <Grid container direction="column" style={{ padding: 15 }}>
                  <Grid
                    item
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {data?.driver_image ? (
                      <Avatar
                        alt="driver profile image"
                        src={data?.driver_image}
                        style={{ width: 100, height: 100, objectFit: "cover" }}
                      />
                    ) : (
                      <AccountCircleIcon sx={{ width: 100, height: 100 }} />
                    )}
                  </Grid>
                  {data &&
                    [
                      { key: "driver_id", label: t("driver_id"), value: data?.driver && role === "admin" ? data.driver : "" },
                      { key: "driver_name", label: t("driver_name"), value: data?.driver_name ? (role === "admin" ? data.driver_name : formatPublicName(data.driver_name)) : "" },
                      { key: "driver_rating", label: (!t("driver_rating") || t("driver_rating") === "driver_rating") ? "Driver Rating" : t("driver_rating"), value: data?.status === "COMPLETE" && ((data?.rating !== undefined && data?.rating !== null) ? data.rating : data?.driverRating) ? renderRatingStars((data?.rating !== undefined && data?.rating !== null) ? data.rating : data?.driverRating) : "" },
                      {
                        key: "driver_contact",
                        label: t("driver_contact"),
                        value:
                          (role === "admin" || role === "driver") && data?.driver_contact
                            ? settings.AllowCriticalEditsAdmin
                              ? data?.driver_contact
                              : t("hidden_demo")
                            : ""
                      },
                      {
                        key: "driver_email", label: t("driver_email"), value: role !== "customer" && data?.driver_email ? (settings.AllowCriticalEditsAdmin
                          ? data?.driver_email
                          : t("hidden_demo")) : ""
                      },
                      { key: "car_type", label: t("car_type"), value: data?.carType ? data.carType : "" },
                      { key: "vehicle_no", label: t("vehicle_no"), value: data?.vehicle_number ? data.vehicle_number : "" },
                      { key: "fleetadmins", label: t("fleetadmins"), value: data?.fleetadmin && role === 'admin' ? data.fleetadmin : "" },
                      { key: "device_id", label: t("device_id"), value: role === "admin" && data?.driverDeviceId ? data.driverDeviceId : "" },

                    ].map((item) =>
                      item.value ? renderGridItem(item, isRTL) : null
                    )}
                </Grid>
              </Card>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Grid item>
              <Card className={classes.card}>
                {renderTypography(t("customer_info"))}
                <Grid container direction="column" style={{ padding: 15 }}>
                  <Grid
                    item
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {data?.customer_image ? (
                      <Avatar
                        alt="customer profile image"
                        src={data?.customer_image}
                        style={{ width: 100, height: 100, objectFit: "cover" }}
                      />
                    ) : (
                      <AccountCircleIcon sx={{ width: 100, height: 100 }} />
                    )}
                  </Grid>
                  {data &&
                    [
                      { key: "customer_id", label: t("customer_id"), value: role === "admin" && data?.customer ? data.customer : "" },
                      { key: "customer_name", label: t("customer_name"), value: data?.customer_name ? (role === "admin" ? data.customer_name : (role === "driver" ? formatPublicName(data.customer_name) : data.customer_name)) : "" },
                      { key: "customer_rating", label: (!t("customer_rating") || t("customer_rating") === "customer_rating") ? "Customer Rating" : t("customer_rating"), value: data?.status === "COMPLETE" && ((data?.customer_rating !== undefined && data?.customer_rating !== null) ? data.customer_rating : data?.customerRating) ? renderRatingStars((data?.customer_rating !== undefined && data?.customer_rating !== null) ? data.customer_rating : data?.customerRating) : "" },
                      {
                        key: "customer_contact",
                        label: t("customer_contact"),
                        value:
                          (role === "admin" || role === "customer") && data?.customer_contact
                            ? settings.AllowCriticalEditsAdmin
                              ? data?.customer_contact
                              : t("hidden_demo")
                            : ""
                      },
                      {
                        key: "customer_email", label: t("customer_email"), value: data?.customer_email ? (settings.AllowCriticalEditsAdmin
                          ? data?.customer_email
                          : t("hidden_demo")) : ""
                      },

                    ].map((item) =>
                      item.value ? renderGridItem(item, isRTL) : null
                    )}
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default BookingDetails;
